import { Callback } from "game-common/models"

import { HudChip } from "./hud_chip"

// The persistent on/off toggle for the ember minimap in the top-right corner. It stays visible
// whether the map is expanded, collapsed, or temporarily covered by another HUD panel.
//
// The plate, the sizing and the tap target all come from HudChip, which the items toggle beside it
// shares, so the row reads as one set of controls.
export class EmberMinimapChip extends HudChip {
    constructor(onClick: Callback) {
        super({ glyph: "🗺", label: "MAP", onClick, toggle: true })
    }
}
